import { Colors, Fonts, Metrics } from "Themes";
import React, { Component } from "react";

import BasicModal from "Modals/BasicModal";
import CropImageModal from "Modals/CropImageModal";
import EditProjectImagesForm from "Forms/EditProjectImagesForm";
import ProjectActions from "Redux/ProjectRedux";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";
import styled from "styled-components";

const Container = styled.div`
  flex: 2;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FileUploadButton = styled.label`
  border-radius: ${Metrics.borderRadius.medium}px;
  padding: 20px;
  font-size: 30px;
  border-radius: 5px;
  color: gray;
  text-align: center;
  cursor: pointer;
  background-color: ${Colors.mainColor};
  font-family: ${Fonts.primaryFontFamily};
  font-size: ${Fonts.fontSize.medium}px;
  color: white;

`;

class ProjectAvatarForm extends Component {
  state = {
    showModal: false,
    showIconModal: false,
    file: null,
    showSuccessAlert: false,
    fetching: false,
  };

  readUrl = async file => {
    const img = file.currentTarget.files[0];
    var reader = new FileReader();
    await reader.readAsDataURL(img);
    reader.onload = () => {
      this.setState({
        showModal: true,
        file: reader.result
      });
    };
  };

  _handleSubmitAvatar = async val => {
    const { updateProjectAvatar, projectDetail } = this.props;
    if (!projectDetail) {
      this.setState({ error: "Project not found" });
      return;
    }

    this.setState({ fetching: true });
    const data = {
      id: projectDetail.id,
      image: val
    };
    const resolve = {
      onSuccess: () => {
        this.setState({ showModal: false, showSuccessAlert: true, fetching: false });
      },
      onFailure: () =>
        this.setState({
          error: true,
          fetching: false,
          success: false
        })
    };
    await updateProjectAvatar(data, resolve);
  };

  _handleSubmitIcon = async icon => {
    const {
      updateProjectIcon,
      projectDetail: { id }
    } = this.props;

    const resolve = {
      onSuccess: () =>
        this.setState({ showIconModal: false, showSuccessAlert: true }),
      onFailure: e =>
        this.setState({
          error: true
        })
    };

    const data = {
      id,
      projectIcon: icon
    };

    await updateProjectIcon(data, resolve);
  };

  renderIconModal = () => {
    const { showIconModal } = this.state;
    return (
      <BasicModal
        show={showIconModal}
        onHide={() => this.setState({ showIconModal: false })}
        title={"Choose an icon"}
      >
        <EditProjectImagesForm handleSubmit={this._handleSubmitIcon} />
      </BasicModal>
    );
  };

  render() {
    const { showModal, file, error, showSuccessAlert, fetching } = this.state;
    const {
      history,
      projectDetail: { id }
    } = this.props;
    return (
      <div style={{ display: "flex", maxWidth: "100%" }}>
        {showSuccessAlert && (
          <SweetAlert
            success
            confirmBtnText="Continue"
            confirmBtnBsStyle="default"
            cancelBtnBsStyle="default"
            title="Project Published!"
            onConfirm={() => history.push(`${navRoutes.editProject}/${id}`)}
          >
            Your project has been published, make sure to keep it updated!
          </SweetAlert>
        )}
        <CropImageModal
          show={showModal}
          onHide={() =>
            this.setState({
              showModal: false
            })
          }
          detail={file}
          handleSubmit={this._handleSubmitAvatar}
          error={error}
          fetching={fetching}
        />
        <Container>
          <FileUploadButton htmlFor="imgupload">
            Click to Upload Avatar
            <input
              type="file"
              id="imgupload"
              onChange={this.readUrl}
              name="avatar"
              style={{
                opacity: 0,
                position: "absolute",
                top: 0,
                left: 0
              }}
              accept="image/png, image/jpeg"
            />
          </FileUploadButton>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    updateProjectAvatar: (data, resolve) =>
      dispatch(ProjectActions.updateProjectAvatarRequest(data, resolve)),
    updateProjectIcon: (data, resolve) =>
      dispatch(ProjectActions.updateProjectIconRequest(data, resolve))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectAvatarForm);
